import { useEffect, useRef } from 'react';

const DETECT_DIRECTION_LIST = ['top', 'bottom'];
const BOUNDING_OFFSET = 200;

function getViewHeight(type, boundingMargin) {
  if (type === 'top') {
    return boundingMargin;
  }

  return window.innerHeight - boundingMargin;
}

function checkInRange(rectY, boundingMargin, type) {
  const viewHeight = getViewHeight(type, boundingMargin);

  const minTopBounding = viewHeight - BOUNDING_OFFSET;
  const maxTopBounding = viewHeight + BOUNDING_OFFSET;

  return rectY <= maxTopBounding && rectY >= minTopBounding;
}

function createBoundingObserverInstance(
  targetElement,
  marginList,
  onScrollBoundingDetectRef,
) {
  if (!targetElement) return null;

  const rootMargin = `${marginList[0]}px 0px ${marginList[1]}px 0px`;

  const observer = new IntersectionObserver(
    ([evt]) => {
      if (evt.intersectionRatio > 1) return;

      const isInView = evt.intersectionRatio !== 0;

      DETECT_DIRECTION_LIST.forEach((direction, index) => {
        if (
          checkInRange(evt.intersectionRect.y, marginList[index], direction) &&
          typeof onScrollBoundingDetectRef.current === 'function'
        ) {
          onScrollBoundingDetectRef.current(direction, isInView, evt);
        }
      });
    },
    {
      threshold: [0.5],
      rootMargin,
    },
  );

  observer.observe(targetElement);

  return observer;
}

const useDetectBounding = (marginList, onScrollBoundingDetect) => {
  const boundingRef = useRef();
  const onScrollBoundingDetectRef = useRef();

  onScrollBoundingDetectRef.current = onScrollBoundingDetect;

  useEffect(() => {
    const observer = createBoundingObserverInstance(
      boundingRef.current,
      marginList,
      onScrollBoundingDetectRef,
    );

    return () => {
      if (!observer) return;
      // eslint-disable-next-line react-hooks/exhaustive-deps
      observer.unobserve(boundingRef.current);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return boundingRef;
};

export default useDetectBounding;
